import(/* webpackMode: "eager" */ "/vercel/path0/app/home-interior/page.tsx");
